import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import LoadSpinner from '../../../components/load-spinner/LoadSpinner';
import CustomTable from '../../../components/custom-table/CustomTable';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import useLog from '../../../hooks/useLog';
import { getDateFormatted, getFormatOraInput } from '../../../utils/dateUtils';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import { setShowDoorHistoryModal } from '../../../slice/showModalSlice';
import { logTypeClass, logTypeIcon, logTypeToString } from '../../../utils/logUtils';

const DoorHistoryModal = () => {
  const dispatch = useDispatch();

  
  const show = useSelector((state) => state.showModal.showDoorHistoryModal);
  const selectedDoor = useSelector((state) => state.editDoor.selectedDoor);

  
  const { logLoading, getHistoryLogs } = useLog();

  
  const [dataTable, setDataTable] = useState([]);
  const [filter, setFilter] = useState({
    startDate: getFormatOraInput(new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)),
    endDate: getFormatOraInput(new Date()),
  });

  
  const headerTable = useMemo(() => ([
    { label: 'Ufficio', field: 'doorName', width: 270 },
    { label: 'Utente', field: 'username', width: 270 },
    { label: 'Evento', field: 'event', width: 270 },
    { label: 'Data', field: 'eventDate', width: 270 },
  ]), []);

  const close = () => {
    dispatch(setShowDoorHistoryModal(false));
  };

  

  const searchHistory = () => {
    if (!selectedDoor?.id) {
      toast.error('Nessuna porta selezionata.');
      return;
    }

    getHistoryLogs(
      {
        
        startDate: new Date(new Date(filter.startDate).setHours(0, 0, 0)).getTime(),
        endDate: new Date(new Date(filter.endDate).setHours(23, 59, 59)).getTime(),
        
        doorId: selectedDoor.id, 
      },
      (data) => {
        
        data.forEach((element) => {
          
          element.doorName = selectedDoor?.name || 'N/A';
          element.event = logTypeToString(element.type)
          element.eventDate = getDateFormatted(new Date(element.eventDate), 'DD/MM/yyyy HH:mm');
        });
        setDataTable(data);
      },
      (error) => {
        toast.error(typeof error === 'string' ? error : 'Errore nel recupero dello storico');
      }
    );
  };

  
  useEffect(() => {
    if (show && selectedDoor?.id) {
      searchHistory();
    }
   
  }, [show, selectedDoor?.id]);

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal show={show} onHide={logLoading ? undefined : close} size="xl" backdrop={logLoading ? 'static' : true}>
      <Modal.Header closeButton>
        <Modal.Title className='text-primary-custom'>Storico — {selectedDoor?.name ?? 'Porta'}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container-fluid">
          <div className="row g-3 mb-3">
            <div className="col-6 d-flex flex-column">
              <label>Data Inizio</label>
              <input
                type="date"
                name="startDate"
                value={filter.startDate}
                max={getFormatOraInput(new Date(filter.endDate))}
                onChange={onChangeFilter}
                className="form-control"
                disabled={logLoading}
              />
            </div>
            <div className="col-6 d-flex flex-column">
              <label>Data Fine</label>
              <input
                type="date"
                name="endDate"
                value={filter.endDate}
                min={getFormatOraInput(new Date(filter.startDate))}
                max={getFormatOraInput(new Date())}
                onChange={onChangeFilter}
                className="form-control"
                disabled={logLoading}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end mb-3">
            <Button className="btn-green" disabled={logLoading} onClick={searchHistory}variant='primary'>
              {loadingWrapper(logLoading, <>Cerca</>)}
            </Button>
          </div>

          {logLoading ? (
            <LoadSpinner />
          ) : (
            <CustomTable
              clickIcon={faMagnifyingGlass}
              header={headerTable}
              data={dataTable}
              checkable={false}
              noClick={true}
              label="Eventi"
              iconField="type"
              iconLabel="Tipo"
              renderIcon={logTypeIcon}
              classFunction={logTypeClass}
              classField="type"
            />
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={close} disabled={logLoading}>
          Chiudi
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DoorHistoryModal;
